module.exports = __webpack_public_path__ + "static/media/Path 377.aec461c1.svg";